export default function compareWordWithWordOfTheDay(inputWord, wordOfTheDay) {
    const result = [];
    const wordOfTheDayArr = wordOfTheDay.split('');
    const inputArr = inputWord.split('');
  
    // Create an array to track how many times each letter has been used for yellow coloring
    const wordOfTheDayLetterCount = {};
  
    // Initialize the letter counts for the word of the day
    wordOfTheDayArr.forEach(letter => {
      wordOfTheDayLetterCount[letter] = (wordOfTheDayLetterCount[letter] || 0) + 1;
    });
  
    inputArr.forEach((letter, index) => {
      if (wordOfTheDayArr[index] === letter) {
        // If the letter matches at the same position, color it green
        result.push({ letter, color: '#27ae60' });
        wordOfTheDayLetterCount[letter] -= 1;  // Reduce count for this letter as it's matched
      } else if (wordOfTheDayArr.includes(letter) && wordOfTheDayLetterCount[letter] > 0) {
        // If the letter exists in the word of the day and hasn't been exhausted, color it yellow
        result.push({ letter, color: '#f39c12' });
        wordOfTheDayLetterCount[letter] -= 1;  // Reduce count for this letter after it's colored yellow
      } else {
        // Otherwise, color the letter white
        result.push({ letter, color: 'white' });
      }
    });
  
    return result;
  }
  